var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsThinkboxFrost32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-ThinkBox-Frost_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-ThinkBox-Frost_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/AWS-ThinkBox-Frost_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.032,25.566 L16.032,22.233 L16.032,19.809 L18.526,18.562 L21.032,19.88 L21.032,25.566 Z M10.032,25.566 L10.032,19.88 L12.538,18.562 L15.032,19.809 L15.032,22.233 L10.032,25.566 Z M4.524,16 L9.616,13.03 L12.032,14.302 L12.032,17.698 L9.616,18.97 L4.524,16 Z M10.032,6.434 L15.032,9.768 L15.032,12.191 L12.538,13.438 L10.032,12.12 L10.032,6.434 Z M15.532,18.941 L13.032,17.691 L13.032,14.309 L15.532,13.059 L18.032,14.309 L18.032,17.691 L15.532,18.941 Z M21.032,6.434 L21.032,12.12 L18.526,13.438 L16.032,12.191 L16.032,9.768 L21.032,6.434 Z M26.54,16 L21.448,18.97 L19.032,17.698 L19.032,14.302 L21.448,13.03 L26.54,16 Z M28.254,20.448 L27.81,19.552 L25.097,20.891 L22.492,19.52 L27.784,16.432 C27.937,16.342 28.032,16.178 28.032,16 C28.032,15.822 27.937,15.658 27.784,15.568 L22.492,12.481 L25.097,11.109 L27.81,12.448 L28.254,11.552 L26.191,10.534 L28.264,9.442 L27.8,8.558 L25.703,9.661 L25.955,7.447 L24.961,7.334 L24.632,10.225 L22.032,11.593 L22.032,5.5 C22.032,5.316 21.93,5.146 21.768,5.059 C21.606,4.973 21.409,4.982 21.255,5.084 L16.032,8.566 L16.032,5.741 L18.344,3.891 L17.719,3.109 L16.032,4.46 L16.032,2 L15.032,2 L15.032,4.46 L13.345,3.109 L12.719,3.891 L15.032,5.741 L15.032,8.566 L9.809,5.084 C9.655,4.982 9.459,4.973 9.296,5.059 C9.134,5.146 9.032,5.316 9.032,5.5 L9.032,11.593 L6.432,10.225 L6.103,7.334 L5.109,7.447 L5.361,9.661 L3.264,8.558 L2.8,9.442 L4.873,10.534 L2.81,11.552 L3.254,12.448 L5.967,11.109 L8.572,12.481 L3.28,15.568 C3.127,15.658 3.032,15.822 3.032,16 C3.032,16.178 3.127,16.342 3.28,16.432 L8.572,19.52 L5.967,20.891 L3.254,19.552 L2.81,20.448 L4.873,21.466 L2.8,22.558 L3.264,23.442 L5.361,22.339 L5.109,24.553 L6.103,24.666 L6.432,21.775 L9.032,20.407 L9.032,26.5 C9.032,26.685 9.134,26.854 9.296,26.941 C9.459,27.028 9.655,27.018 9.809,26.916 L15.032,23.435 L15.032,26.259 L12.719,28.109 L13.345,28.891 L15.032,27.54 L15.032,30 L16.032,30 L16.032,27.54 L17.719,28.891 L18.344,28.109 L16.032,26.259 L16.032,23.435 L21.255,26.916 C21.339,26.972 21.435,27 21.532,27 C21.613,27 21.694,26.981 21.768,26.941 C21.93,26.854 22.032,26.685 22.032,26.5 L22.032,20.407 L24.632,21.775 L24.961,24.666 L25.955,24.553 L25.703,22.339 L27.8,23.442 L28.264,22.558 L26.191,21.466 L28.254,20.448 Z",
    id: "AWS-ThinkBox-Frost_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsThinkboxFrost32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Thinkbox-Frost_32.45b7a7ea1650ff2e066fb050cd17f177.svg";
export { ForwardRef as ReactComponent };